import { Item } from '@radix-ui/react-context-menu'
import styled from 'styled-components'

export const StyledNewContextMenuItem = styled(Item)`
  display: flex;
  align-items: center;
  gap: ${props => props.theme.spacings.small};
  padding: ${props => props.theme.spacings.small};
  position: relative;
  user-select: none;
  cursor: pointer;

  &[data-disabled] {
    opacity: ${props => props.theme.opacities.disabled};
    pointer-events: 'none';
    cursor: not-allowed;
  }

  &[data-highlighted] {
    background-color: ${props => props.theme.colors.neutral.lighter};
  }
`
